export const isNullOrEmpty = (value) => {
  return value === null || value === '' || value === undefined;
};
